import { useMemo } from "react";
import { useMandatorContext } from "@bn/theming";
import { mandatorLinks, MandatorLinks, resolvePortalUrl } from "@helpers";

export const useMandatorLinks = (): MandatorLinks => {
  const { mandatorSlug } = useMandatorContext();

  return useMemo(() => {
    const links = mandatorLinks[mandatorSlug] ?? mandatorLinks.boersennews_de;

    return {
      ...links,
      logoutRedirectUrl: resolvePortalUrl(links.logoutRedirectUrl),
      logoutApiUrl: resolvePortalUrl(links.logoutApiUrl),
    };
  }, [mandatorSlug]);
};
